<div
  #cartList="cdkDropList"
  className='emptyCell'
   cdkDropList
  [cdkDropListData]="item"
  [cdkDropListConnectedTo]="getConnectedLists()"
  (cdkDropListDropped)="drop($event)"
>


  DROP an Item here
</div>